import axios from 'axios';
import Cookies from 'js-cookie';
import { Template } from '../../redux/features/doctor/Dashboard/templates/templates';

// --- Axios Auth Config ---
const getConfig = () => {
  const token = Cookies.get('jwt');
  if (!token) {
    console.error('Authentication token not found.');
  }
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

// This function ensures the environment variable is read correctly every time.
const getApiUrl = (path: string = '') => {
  const baseUrl = process.env.REACT_APP_BACKEND_URL;
  if (!baseUrl) {
    console.warn(
      'Warning: REACT_APP_BACKEND_URL is not defined. Falling back to relative path. This may fail if frontend and backend are on different ports.'
    );
    // Fallback for development if the .env is not set up
    return `/api/templates${path}`;
  }
  return `${baseUrl}/templates${path}`;
};


// --- API Functions ---

/**
 * Fetches all templates for the current user.
 * Corresponds to: GET /api/templates
 */
export const apiFetchTemplates = async () => {
  return axios.get(getApiUrl(), getConfig());
};

/**
 * Fetches a single template by its unique ID.
 * Corresponds to: GET /api/templates/:templateId
 */
export const apiFetchTemplateById = async (templateId: string) => {
  return axios.get(getApiUrl(`/${templateId}`), getConfig());
};

/**
 * Creates a new, empty template.
 * Corresponds to: POST /api/templates
 */
export const apiCreateEmptyTemplate = async (title: string, language: string) => {
  const body = { title, language };
  return axios.post(getApiUrl(), body, getConfig());
};

/**
 * Creates a new template by sending unstructured text to the AI parser.
 * Corresponds to: POST /api/templates/parse
 */
export const apiCreateTemplateFromText = async (title: string, language: string, text: string) => {
  const body = { title, language, text };
  return axios.post(getApiUrl('/parse'), body, getConfig());
};

/**
 * Updates an existing template.
 * Corresponds to: PUT /api/templates/:templateId
 */
export const apiUpdateTemplate = async (template: Template) => {
  return axios.put(getApiUrl(`/${template._id}`), template, getConfig());
};

/**
 * Deletes a template by its ID.
 * Corresponds to: DELETE /api/templates/:templateId
 */
export const apiDeleteTemplate = async (templateId: string) => {
  return axios.delete(getApiUrl(`/${templateId}`), getConfig());
};